const initialState = {
  selectedYacht: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SELECT_YACHT':
      return {
        ...state,
        selectedYacht: action.yacht,
      };

    default:
      return state;
  }
};
